export default "__VITE_ASSET__529009f0__"